import { makeStyles } from 'tss-react/mui';

const name = 'CodeExampleButton';

export const useCodeExampleButtonStyles = makeStyles({ name })(theme => ({
  root: {
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },

    '&:disabled': {
      backgroundColor: 'transparent',
    },
  },
}));
